import { render, staticRenderFns } from "./AvatarProfilePicture.vue?vue&type=template&id=28002150&scoped=true&"
import script from "./AvatarProfilePicture.vue?vue&type=script&lang=js&"
export * from "./AvatarProfilePicture.vue?vue&type=script&lang=js&"
import style0 from "./AvatarProfilePicture.vue?vue&type=style&index=0&id=28002150&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28002150",
  null
  
)

export default component.exports